import { Component, OnInit } from "@angular/core";
import { StatsService } from "@/_services/stats.service";
import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";
import { buildPastDaysDateRange } from "@/_utility/date.utils";
import {
    StatsAssuranceFilter,
    StatsAssuranceResult,
} from "@/_models/stats-assurance.interface";

@Component({
    selector: "app-performance-assurance",
    templateUrl: "./performance-assurance.component.html",
    styleUrls: ["./performance-assurance.component.scss"],
})
export class PerformanceAssuranceComponent implements OnInit {
    stats$: Observable<StatsAssuranceResult>;
    filters: StatsAssuranceFilter;

    constructor(private statsService: StatsService) {}

    ngOnInit(): void {
        const [defaultStart, defaultEnd] = buildPastDaysDateRange(-30);
        this.filters = {
            caseDate: [defaultStart, defaultEnd],
        };

        this.stats$ = this.statsService
            .getAssuranceStats(this.filters)
            .pipe(shareReplay());
    }
}
